import axiosInstance from "../../../redux/api";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";
import { isAllowedFile } from "../../../assests/extention/fileextention";

/**
 * Validates file signature via backend API.
 * @param {File|File[]} files - The file or array of files to validate.
 * @returns {Promise<{status: boolean, message: string}>} - The validation result from the API.
 */
const validateFile = async (files) => {
  console.log("validateFile utility called with files:", files);
  // const toastId = urtoast("Validating file(s)...", 0); // Show loading toast
  try {
    const formData = new FormData();
    const fileArray = Array.isArray(files) ? files : [files];

    for (const file of fileArray) {
      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Please upload a valid file type.", 2);
        return {
          status: false,
          message: "Unsupported file format. Please upload a valid file type.",
        };
      }
      console.log("Appending file to FormData:", file.name, file.type, file.size);
      formData.append("file[]", file);
    }

    console.log("Sending POST request to validate_file via axiosInstance...");
    const response = await axiosInstance.post("validate_file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Raw Axios Response:", response);
    console.log("Validation API Data Content:", response.data);

    // urtoast("Validation complete", 1); // Success toast

    return {
      status: response?.data?.status ?? false,
      message: response?.data?.message ?? "Validation failed",
    };
  } catch (err) {
    console.error("File validation exception caught:", err);
    urtoast("Validation service error", 2);
    return {
      status: false,
      message: "Something went wrong while validating the file",
    };
  }
};

export default validateFile;